/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AzureApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `AzureApiModule.forRoot()`
 */
export interface AzureApiConfigurationParams {
  rootUrl?: string;
}
